import packageJSON from "../../../package.json";

export const sentryWhiteSet = new Set(["dev", "test", "prod"]);

export const getIsStartSentry = () => {
  if (process.env.NODE_ENV === "development") {
    return false;
  }

  return sentryWhiteSet.has(getEnviroment());
};

export const getEnviroment = (): string => {
  return process.env.REACT_APP_ENV as string;
};

export const getIsApac = () => {
  return process.env.REGION === "apac";
};

export const getApplication = () => {
  return `${packageJSON.name}@${packageJSON.version}`;
};

export const getApplicationName = () => {
  return packageJSON.name;
};

export const getApplicationVersion = () => {
  return packageJSON.version;
};
